import { render, staticRenderFns } from "./AnimatedNumber.vue?vue&type=template&id=ebdb6984&scoped=true"
import script from "./AnimatedNumber.vue?vue&type=script&lang=js"
export * from "./AnimatedNumber.vue?vue&type=script&lang=js"
import style0 from "./AnimatedNumber.vue?vue&type=style&index=0&id=ebdb6984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdb6984",
  null
  
)

export default component.exports